import HttpService from './HttpService';

const ForesightApi = HttpService('/api/foresightapi/');
const doPost = (action, data) => ForesightApi.post(action, data);
const doGet = (url) => ForesightApi.get(url);

export default {
  getVoyageForesightDetails(siteId, voyageNo, vesselName) {
    const queryString = `siteId=${siteId}&voyageNo=${voyageNo}&vesselName=${vesselName}`;
    const apiAction = 'GetForesightVoyageDetails';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
};
